import { useLocation } from "react-router-dom";
import { Loader } from "components/wrapper/fullPageLoader";
import { useEffect, useMemo, useState, memo } from "react";
import { Select, Option } from "@sajari/react-components";
import Divider from "@mui/material/Divider";
import { Helmet } from "react-helmet";
import ProductList from "./productList";
import "./style.css";
import "styles/common.css";
import "styles/responsive-common.css";
import "components/Layout/SiteContent/ExploreProductsPage/style.css";
import BasicBreadcrumbs from "components/Breadcrumbs";
import { useInfiniteHits, useSearchBox } from "react-instantsearch-hooks-web";
import {
  searchClient,
  searchClientIndex,
  paysfer_price_asc_virtual,
  paysfer_price_desc_virtual,
} from "App";
import { RefinementList } from "react-instantsearch-hooks-web";
import { useRefinementList } from "react-instantsearch-hooks-web";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import {
  useClearRefinements,
  useNumericMenu,
  useSortBy,
  RangeInput,
  useRange,
} from "react-instantsearch-hooks-web";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Checkbox from "@mui/material/Checkbox";
import Drawer from "@mui/material/Drawer";
import Snack from "components/wrapper/snack";

function SearchResults() {
  const location: any = useLocation();
  const [selectedPrice, setSelectedPrice] = useState<any>("%7B%7D");
  const [selectedCategory, setSelectedCategory] = useState<any>();
  const [selectedSize, setSelectedSize] = useState<any>();
  const [selectedBrand, setSelectedBrand] = useState<any>();
  const [filter, setfilter] = useState<any>(false);
  const [minPrice, setMinPrice] = useState<any>(null);
  const [maxPrice, setMaxPrice] = useState<any>(null);
  const { results } = useInfiniteHits();
  const params = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const { query, refine } = useSearchBox();
  // console.log(results?.hits, "algolia results");
  const refinementListApi = useRefinementList({
    attribute: "brand",
    limit: 5000,
  });
  const { items: colorItem, refine: colorRefine } = useRefinementList({
    attribute: "color",
    limit: 23,
  });
  const { items: categoryItem, refine: categoryRefine } = useRefinementList({
    attribute: "category",
    limit: 10,
  });
  const { items: brandItem, refine: brandFilterRefine } = useRefinementList({
    attribute: "brand",
    limit: 5,
  });
  const { items: sizeItem, refine: sizeFilterRefine } = useRefinementList({
    attribute: "size0",
    limit: 10,
  });
  const clearRefinementsApi = useClearRefinements({
    includedAttributes: ["color"],
  });
  const { refine: clearColor } = clearRefinementsApi;
  const brandRefinementsApi = useClearRefinements({
    includedAttributes: ["brand"],
  });
  const { refine: clearBrand } = brandRefinementsApi;
  const categoryClearRefinementsApi = useClearRefinements({
    includedAttributes: ["category"],
  });
  const { refine: clearCategory } = categoryClearRefinementsApi;
  //size
  const sizeClearRefinementsApi = useClearRefinements({
    includedAttributes: ["size0"],
  });
  const { refine: clearSize } = sizeClearRefinementsApi;
  const numericMenuApi = useNumericMenu({
    attribute: "price0",
    items: [
      { label: "All" },
      { label: "Less than 25$", end: 25 },
      { label: "Between 25$ - 50$", start: 25, end: 50 },
      { label: "More than 50$", start: 50 },
    ],
  });

  const { items: priceItems, refine: priceRefine } = numericMenuApi;
  // console.log(priceItems, "check price items");
  const { items } = refinementListApi;
  const sortByApi = useSortBy({
    items: [
      { label: "Most Relevant", value: "paysfer" },
      { label: "price (asc)", value: "paysfer_price_asc_virtual" },
      { label: "price (desc)", value: "paysfer_price_desc_virtual" },
    ],
  });
  const { refine: brandRefine } = sortByApi;

  const rangeApi = useRange({
    attribute: "price0",
  });

  const { refine: priceRangeRefine } = rangeApi;
  // console.log(refinementListApi, "Check Refine API");
  const [size, setSize] = useState({
    x: window.innerWidth,
    y: window.innerHeight,
  });
  const updateSize = () =>
    setSize({
      x: window.innerWidth,
      y: window.innerHeight,
    });
  useEffect(() => (window.onresize = updateSize), []);
  useEffect(() => {
    refine(params.get("q") as string);
  }, [params]);

  const onRangeSubmit = (min: any, max: any): any => {
    // if (!isNaN(Number(min)) || !isNaN(Number(max))) {
    //   Snack.error("Enter valid numbers");
    //   return;
    // }
    if (max == null || min == null) {
      Snack.error("Enter both max and min values");
      return;
    }
    if (Number(max) < Number(min)) {
      Snack.error("Max value should be greater than Min value");
      return;
    }
    setSelectedPrice(null);
    priceRangeRefine([min, max]);
  };

  const isConditionMet = size.x < 1000;
  const classNameforProducts = isConditionMet
    ? "col-12 col-lg-12"
    : "col-12 col-lg-10";

  return (
    <section className="search-product-section custom-spacer">
      <div className="continer-fluid">
        <div className="row">
          {/**Filters.... */}
          <div className="col-12 col-lg-2">
            <div
              className="filter-bar"
              style={size.x < 1000 ? { display: "none" } : { display: "block" }}
            >
              {location?.state?.searched && (
                <div>
                  <FormGroup>
                    <FormLabel component="legend">Price</FormLabel>
                    {priceItems.map((item) => {
                      return (
                        <p
                          className={
                            selectedPrice === item.value
                              ? "selectedItem"
                              : "unselectedItem"
                          }
                          onClick={() => {
                            setSelectedPrice(item.value);
                            priceRefine(item.value);
                          }}
                        >
                          {item.label}
                        </p>
                      );
                    })}
                  </FormGroup>
                  <div
                    style={{
                      display: "flex",
                      gap: "0.2em",
                      marginLeft: "0em",
                      marginTop: "0.5em",
                    }}
                  >
                    <input
                      type="text"
                      className="inputStyle"
                      placeholder="$ MIN"
                      onChange={(event) => setMinPrice(event.target.value)}
                    />
                    <input
                      type="text"
                      className="inputStyle"
                      placeholder="$ MAX"
                      onChange={(event) => setMaxPrice(event.target.value)}
                    />
                    <button
                      className="submit-btn"
                      onClick={() => onRangeSubmit(minPrice, maxPrice)}
                    >
                      GO
                    </button>
                  </div>
                  <br />
                  <p
                    style={{
                      color: "#a2a6af",
                      fontSize: "12px",
                      marginBottom: "0.5em",
                    }}
                  >
                    Category
                  </p>
                  <RefinementList
                    attribute="category"
                    limit={5}
                    showMore={false}
                    showMoreLimit={1000}
                    searchablePlaceholder="category"
                  />
                  <br />
                  <p
                    style={{
                      color: "#a2a6af",
                      fontSize: "12px",
                      marginBottom: "0.5em",
                    }}
                  >
                    Brand
                  </p>
                  <RefinementList
                    attribute="brand"
                    limit={5}
                    showMore={false}
                    showMoreLimit={1000}
                    searchablePlaceholder="brands"
                  />
                  <br />
                  <p
                    style={{
                      color: "#a2a6af",
                      fontSize: "12px",
                      marginBottom: "0.5em",
                    }}
                  >
                    Size
                  </p>
                  <RefinementList
                    attribute="size0"
                    limit={5}
                    showMore={false}
                    showMoreLimit={30}
                    searchablePlaceholder="size"
                  />
                  <br />
                  <p
                    style={{
                      color: "#a2a6af",
                      fontSize: "12px",
                      marginBottom: "0.5em",
                    }}
                  >
                    Gender
                  </p>
                  <RefinementList
                    attribute="gender0"
                    limit={5}
                    showMore={false}
                    showMoreLimit={1000}
                    searchablePlaceholder="gender"
                  />
                  <br />
                  <br />
                  {colorItem.length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <p
                        style={{
                          color: "#a2a6af",
                          fontSize: "12px",
                          marginBottom: "0.5em",
                        }}
                      >
                        COLOR
                      </p>
                      <p
                        style={{
                          color: "#76A9FA",
                          cursor: "pointer",
                          fontSize: "12px",
                          marginBottom: "0.5em",
                          fontWeight: 400,
                        }}
                        onClick={() => clearColor()}
                      >
                        RESET
                      </p>
                    </div>
                  )}
                  {/* <Filter type="color" name="color" title="Color" /> */}
                  <ul className="color-filter-container">
                    {colorItem.map((item) => (
                      <li key={item.label}>
                        <button
                          className="color-filter-button"
                          style={{ backgroundColor: item.label }}
                          onClick={() => colorRefine(item.value)}
                        >
                          {/* {item.label} */}
                        </button>
                      </li>
                    ))}
                  </ul>
                  <br />
                  <br />
                </div>
              )}
            </div>
          </div>
          {/* *Mobile View Filters */}
          <Drawer
            anchor={"bottom"}
            open={filter}
            onClose={() => setfilter(!filter)}
            style={{ padding: "25px" }}
          >
            <div
              style={{
                marginLeft: "1em",
                marginRight: "1em",
                marginTop: "0.5em",
                maxHeight: "300px",
                overflowY: "scroll",
              }}
            >
              <FormGroup>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <p
                    style={{
                      // color: "#a2a6af",
                      fontSize: "23px",
                      marginBottom: "0.5em",
                      fontWeight: "bold",
                    }}
                  >
                    FILTERS
                  </p>
                  <p
                    style={{
                      color: "#76A9FA",
                      cursor: "pointer",
                      fontSize: "23px",
                      marginBottom: "0.5em",
                      fontWeight: "bold",
                    }}
                    onClick={() => setfilter(!filter)}
                  >
                    X
                  </p>
                </div>
                <Divider />
                <br />
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <p
                    style={{
                      // color: "#a2a6af",
                      fontSize: "23px",
                      marginBottom: "0.5em",
                      fontWeight: "bold",
                    }}
                  >
                    CATEGORY
                  </p>
                  <p
                    style={{
                      color: "#76A9FA",
                      cursor: "pointer",
                      fontSize: "23px",
                      marginBottom: "0.5em",
                      fontWeight: "bold",
                    }}
                    onClick={() => {
                      clearCategory();
                      setSelectedCategory(null);
                    }}
                  >
                    RESET
                  </p>
                </div>
                {categoryItem.map((item) => {
                  return (
                    <p
                      className={
                        selectedCategory === item.value
                          ? "selectedItem"
                          : "unselectedItem"
                      }
                      style={{ fontSize: "20px" }}
                      onClick={() => {
                        setSelectedCategory(item.value);
                        categoryRefine(item.value);
                      }}
                    >
                      {item.label}
                    </p>
                  );
                })}

                <br />
                <Divider />
                <br />
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <p
                    style={{
                      // color: "#a2a6af",
                      fontSize: "23px",
                      marginBottom: "0.5em",
                      fontWeight: "bold",
                    }}
                  >
                    BRAND
                  </p>
                  <p
                    style={{
                      color: "#76A9FA",
                      cursor: "pointer",
                      fontSize: "23px",
                      marginBottom: "0.5em",
                      fontWeight: "bold",
                    }}
                    onClick={() => {
                      clearBrand();
                      setSelectedBrand(null);
                    }}
                  >
                    RESET
                  </p>
                </div>
                {brandItem.map((item) => {
                  return (
                    <p
                      className={
                        selectedBrand === item.value
                          ? "selectedItem"
                          : "unselectedItem"
                      }
                      style={{ fontSize: "20px" }}
                      onClick={() => {
                        setSelectedBrand(item.value);
                        brandFilterRefine(item.value);
                      }}
                    >
                      {item.label}
                    </p>
                  );
                })}
                <br />
                <Divider />
                <br />
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <p
                    style={{
                      // color: "#a2a6af",
                      fontSize: "23px",
                      marginBottom: "0.5em",
                      fontWeight: "bold",
                    }}
                  >
                    SIZE
                  </p>
                  <p
                    style={{
                      color: "#76A9FA",
                      cursor: "pointer",
                      fontSize: "23px",
                      marginBottom: "0.5em",
                      fontWeight: "bold",
                    }}
                    onClick={() => {
                      clearSize();
                      setSelectedSize(null);
                    }}
                  >
                    RESET
                  </p>
                </div>
                {sizeItem.map((item) => {
                  return (
                    <p
                      className={
                        selectedSize === item.value
                          ? "selectedItem"
                          : "unselectedItem"
                      }
                      style={{ fontSize: "20px" }}
                      onClick={() => {
                        setSelectedSize(item.value);
                        sizeFilterRefine(item.value);
                      }}
                    >
                      {item.label}
                    </p>
                  );
                })}
                <br />
                <Divider />
                <br />
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <p
                    style={{
                      // color: "#a2a6af",
                      fontSize: "23px",
                      marginBottom: "0.5em",
                      fontWeight: "bold",
                    }}
                  >
                    PRICE
                  </p>
                </div>
                {priceItems.map((item) => {
                  return (
                    <p
                      className={
                        selectedPrice === item.value
                          ? "selectedItem"
                          : "unselectedItem"
                      }
                      style={{ fontSize: "20px" }}
                      onClick={() => {
                        setSelectedPrice(item.value);
                        priceRefine(item.value);
                      }}
                    >
                      {item.label}
                    </p>
                  );
                })}
              </FormGroup>
              <br />
              <br />
            </div>
          </Drawer>
          {/**Products.... */}
          <div
            className={classNameforProducts}
            style={
              size.x < 1000 ? { paddingLeft: "20px", marginTop: "0.5em" } : {}
            }
          >
            <div className="col-12 col-lg-3">
              <b style={{ fontSize: "0.875em" }}>{results?.nbHits} Products</b>
            </div>
            <div className="col-12 col-lg-3">
              <Helmet>
                <title>{`Paysfer eMart : ${
                  location?.state?.value || "Your One-Stop Shop: Buy More, Spend Less Today!"
                }`}</title>
                <meta
                  name="description"
                  content={`Paysfer eMart : ${
                    location?.state?.value || "Your One-Stop Shop: Buy More, Spend Less Today!"
                  }`}
                />
              </Helmet>
              {size.x > 1000 ? (
                <div
                  style={{
                    width: "150px",
                    marginBottom: "0.5em",
                    display: "flex",
                    gap: "0.5em",
                    alignItems: "baseline",
                  }}
                >
                  <p style={{ color: "#A2A6AF", float: "right" }}>Sort</p>
                  <Select
                    value={""}
                    onChange={(value: any) =>
                      brandRefine(value === "" ? "paysfer" : value)
                    }
                    size="sm"
                  >
                    <Option value="">Most relevant</Option>
                    <Option value="paysfer_price_asc_virtual">
                      Price: low to high
                    </Option>
                    <Option value="paysfer_price_desc_virtual">
                      Price: high to low
                    </Option>
                  </Select>
                </div>
              ) : (
                <p
                  style={{
                    color: "#4284F3",
                    fontWeight: "bold",
                    float: "right",
                    cursor: "pointer",
                  }}
                  onClick={() => setfilter(true)}
                >
                  FILTER
                  <FontAwesomeIcon icon={faFilter} />
                </p>
              )}

              <div role="presentation" style={{ marginBottom: "0.5em" }}>
                <BasicBreadcrumbs query={query} isProductPage={false} />
              </div>
            </div>
            <ProductList />
            {/* <div className="flex-1 pl-4">
              <Results />
            </div>
            <div className="col-3">
              <ResultsPerPage size="sm" />
            </div>
            <div className="col-3">
              <ViewType size="sm" />
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default memo(SearchResults);
